var TermsAndConditions = (function ($, Backbone) {

	var TermsAndConditions = Backbone.Model.extend({

		initialize: function (attrs, opts) {
			opts && this.setState(opts.termsMode);
		},

		isValid: function () {
			return this.get('Value');
		},

		setState: function (termsMode) {
            termsMode = termsMode || 0;
            var disabled = this.get('Disabled');
            var value = this.get('Value');

            disabled === undefined && this.set('Disabled', termsMode === 0);
            value === undefined && this.set('Value', termsMode === 0 || termsMode === 2); // set to true if disabled
		}
	});

	return TermsAndConditions;
})($, Backbone);